// ServiceCardsSection.js
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import ConsultationModal from './ConsultationModal';

const ServiceCardsSection = () => {
  const [showConsultationModal, setShowConsultationModal] = useState(false);

  const services = [
    {
      tag: 'Education',
      title: 'Studying Overseas',
      description: 'We narrow the field to institutions that fit your grades and budget, then work through the application itself, statement included, until it is filed.',
      link: '/study-abroad',
      cta: 'Study routes',
      color: 'blue'
    },
    {
      tag: 'Employment',
      title: 'Working Overseas',
      description: 'We introduce candidates to employers hiring from abroad and prepare you properly for the interview, the paperwork and the questions that follow it.',
      link: '/work-abroad',
      cta: 'Work routes',
      color: 'red'
    },
    {
      tag: 'Assessment',
      title: 'Where You Stand',
      description: 'A one to one review of your qualifications, funds and timing, so you know which routes are realistically open before you spend anything.',
      action: 'consultation',
      cta: 'Book a review',
      color: 'yellow'
    },
    {
      tag: 'Preparation',
      title: 'Getting You Ready',
      description: 'Checking documents before they go out, rehearsing interviews, and keeping a running list of what is done and what is still outstanding.',
      action: 'consultation',
      cta: 'Start here',
      color: 'green'
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      blue: 'border-t-blue-500',
      red: 'border-t-red-500',
      yellow: 'border-t-yellow-500',
      green: 'border-t-green-500'
    };
    return colors[color] || 'border-t-blue-500';
  };

  const getSquareColorClasses = (color) => {
    const colors = {
      blue: 'bg-blue-500',
      red: 'bg-red-500',
      yellow: 'bg-yellow-500',
      green: 'bg-green-500'
    };
    return colors[color] || 'bg-blue-500';
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Service Cards Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className={`bg-surface p-8 border-t-2 ${getColorClasses(service.color)} hover:shadow-lg transition-shadow`}
            >
              <div className="flex items-center gap-2 mb-6">
                <span className={`w-2 h-2 ${getSquareColorClasses(service.color)}`}></span>
                <span className="text-sm font-normal text-gray-600">
                  {service.tag}
                </span>
              </div>
              
              <h3 className="text-xl font-semibold text-primary mb-4 leading-tight">
                {service.title}
              </h3>
              
              <p className="text-gray-600 text-sm font-light leading-relaxed mb-8">
                {service.description}
              </p>
              
              {service.link ? (
                <Link 
                  to={service.link}
                  className="text-primary text-sm font-normal hover:underline inline-block border-b border-primary pb-1"
                >
                  {service.cta}
                </Link>
              ) : (
                <button
                  onClick={() => setShowConsultationModal(true)}
                  className="text-primary text-sm font-normal hover:underline inline-block border-b border-primary pb-1"
                >
                  {service.cta}
                </button>
              )}
            </motion.div>
          ))}
        </div>
      </div>

      {/* Consultation Modal */}
      <ConsultationModal 
        isOpen={showConsultationModal}
        onClose={() => setShowConsultationModal(false)}
        serviceType="general"
      />
    </section>
  );
};

export default ServiceCardsSection;
